import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { TranslationType as TranslationTypeEnum } from '@square/dashboard-protos/models/squareup/beemo/translation_types';

// if this proto is updated, you should also update common.translationTypes in en.yml
export const TranslationType = new Enum(Object.keys(TranslationTypeEnum));

// This will override the common translation types defined above and in
// common.translationTypes in en.module.js
export const RestaurantsTranslationType = new Enum('NO_TICKET_GROUP'
// if you add something here, update restaurants.translationTypes in en.yml
// make sure these two comments remain the last in the enum :)
);
export default ProtoBaseModel.extend({
  name: attr(String),
  translationType: attr(TranslationType)
});